// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__VFkDp","validationTips":"StatementDescriptor_validationTips__215ae"};